'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.Alert');

var _Container2 = _interopRequireDefault(_Container);

var _Icon = require('./components/Icon.Alert');

var _Icon2 = _interopRequireDefault(_Icon);

var _Undo = require('./components/Undo.Alert');

var _Undo2 = _interopRequireDefault(_Undo);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getIcon = function getIcon(type) {
  switch (type) {
    case 'error':
      return 'closecircle';

    case 'warning':
      return 'exclamationcircle';

    case 'info':
      return 'infocirlce';

    case 'success':
      return 'checkcircle';

    default:
      return 'closecircle';
  }
}; // Components


var Alert = function Alert(_ref) {
  var type = _ref.type,
      children = _ref.children,
      action = _ref.action,
      label = _ref.label;
  return _react2.default.createElement(_Container2.default, {
    type: type
  }, _react2.default.createElement(_Icon2.default, {
    icon: getIcon(type)
  }), _react2.default.createElement('div', null, children), action !== null && _react2.default.createElement(_Undo2.default, {
    onClick: action
  }, label));
};

Alert.propTypes = {
  type: _propTypes2.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  children: _propTypes2.default.node.isRequired,
  action: _propTypes2.default.func,
  label: _propTypes2.default.node
};
Alert.defaultProps = {
  action: null,
  label: 'undo'
};
exports.default = Alert;